import {DashboardClientModel, DashboardProfessionalModel} from '../../../../functions/src/data/dashboard-model';
import {Actions, ActionTypes} from './actions';

export interface State {
  dashboardData: DashboardClientModel | DashboardProfessionalModel;
}

export const initialState: State = getInitState();

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.Init:
      return {
        ...state
      };
    case ActionTypes.LoadDashboardDataResponse:
      if (action.payload.response.isSuccess) {
        return {
          ...state,
          dashboardData: action.payload.response.responseData
        };
      } else {
        return state;
      }
  }
  return state;
}

function getInitState(): State {
  return {
    dashboardData: null
  };
}

// Pure Functions
export const getDashboardData = (state: State) => state.dashboardData;
